import { useState } from 'react';

export function useSettingsForm() {
  const [formData, setFormData] = useState({
    nameEn: '',
    nameAr: '',
    descriptionEn: '',
    descriptionAr: '',
    address: '',
    phone: '',
    latitude: '',
    longitude: '',
    imageUrl: '',
    backgroundImageUrl: '',
    rating: 5.0,
    workingDays: [],
    openingTime: '',
    closingTime: '',
    cliqAlias: '',
    cliqAliasDisplayedName: '',
    iban: '',
    minimumDaysBeforeSubscriptionCreation: 2,
    mustSelectMealsBeforeDays: 2,
    tags: []
  });

  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
  };

  const handleWorkingDayToggle = (day) => {
    setFormData(prev => ({
      ...prev,
      workingDays: prev.workingDays.includes(day)
        ? prev.workingDays.filter(d => d !== day)
        : [...prev.workingDays, day]
    }));
  };

  const handleTagAdd = (tag) => {
    if (tag && !formData.tags.includes(tag)) {
      setFormData(prev => ({
        ...prev,
        tags: [...prev.tags, tag]
      }));
    }
  };

  const handleTagRemove = (tagToRemove) => {
    setFormData(prev => ({
      ...prev,
      tags: prev.tags.filter(tag => tag !== tagToRemove)
    }));
  };

  return {
    formData,
    setFormData,
    handleInputChange,
    handleWorkingDayToggle,
    handleTagAdd,
    handleTagRemove
  };
}
